import React from "react";
import Heading from "../LandingPage/Heading";

const features = [
  {
    title: "Secure & Controlled",
    description:
      "Your funds remain in your account, with trading managed by expert strategies.",
    icon: (
      <svg
        width="55"
        height="49"
        viewBox="0 0 55 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M21.9219 4.58057C11.8378 5.05602 3.8125 13.0344 3.8125 22.8055C3.8125 27.647 5.78229 32.0462 8.99538 35.3108C9.70281 36.0297 10.1751 37.0118 9.98452 38.0225C9.66993 39.6752 8.95697 41.2166 7.91305 42.5014C10.6597 43.0127 13.5156 42.5523 15.9648 41.249C16.8306 40.7885 17.2635 40.558 17.569 40.5113C17.8745 40.4646 18.3121 40.5469 19.1872 40.7112C20.403 40.9398 21.6373 41.0542 22.875 41.0527"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M28.6224 5.31755C30.667 4.09814 32.4516 4.58955 33.5239 5.37231C33.9635 5.69327 34.1833 5.85374 34.3125 5.85374C34.4418 5.85374 34.6615 5.69327 35.1011 5.37231C36.1734 4.58955 37.958 4.09814 40.0027 5.31755C42.6863 6.9179 43.2934 12.1975 37.1036 16.6517C35.9246 17.5001 35.3352 17.9243 34.3125 17.9243C33.2898 17.9243 32.7004 17.5001 31.5214 16.6517C25.3316 12.1975 25.9387 6.9179 28.6224 5.31755Z"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
        />{" "}
        <g clip-path="url(#clip0_4127_14691)">
          {" "}
          <path
            d="M27.25 33.615C27.25 40.0539 32.8472 45.2744 39.75 45.2744C40.5616 45.2755 41.371 45.2022 42.1682 45.0564C42.7421 44.9512 43.029 44.8987 43.2293 44.9285C43.4297 44.9584 43.7135 45.1055 44.2813 45.3999C45.8873 46.2327 47.7601 46.5268 49.5611 46.2002C48.8766 45.3792 48.4091 44.3942 48.2028 43.3383C48.0778 42.6924 48.3875 42.0649 48.8514 41.6056C50.9583 39.5196 52.25 36.7087 52.25 33.615C52.25 27.1762 46.6528 21.9556 39.75 21.9556C32.8472 21.9556 27.25 27.1762 27.25 33.615Z"
            stroke="#89A8B0"
            strokeWidth="4"
            strokeLinejoin="round"
          />{" "}
        </g>{" "}
        <defs>
          {" "}
          <clipPath id="clip0_4127_14691">
            {" "}
            <rect
              width="30"
              height="29.25"
              fill="white"
              transform="matrix(-1 0 0 1 54.75 19.5181)"
            />{" "}
          </clipPath>{" "}
        </defs>{" "}
      </svg>
    ),
  },
  {
    title: "Diversified Trading Approach",
    description:
      "Spread risk by investing in multiple strategies across different accounts.",
    icon: (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M10 11.6552H15.4M15.4 11.6552H19M15.4 11.6552V10M22 11.6552H19M19 11.6552C18.367 13.9187 17.0415 16.0585 15.5286 17.9389M15.5286 17.9389C14.2758 19.496 12.8945 20.8754 11.6714 22M15.5286 17.9389C14.7571 17.0345 13.6771 15.5712 13.3686 14.9091M15.5286 17.9389L17.8429 20.3448"
          stroke="#89A8B0"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M27 38L28.6666 34M28.6666 34L32 26L35.3334 34M28.6666 34H35.3334M37 38L35.3334 34"
          stroke="#89A8B0"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M28 20V16C28 10.3431 28 7.51472 26.2426 5.75736C24.4852 4 21.6568 4 16 4C10.3431 4 7.51472 4 5.75736 5.75736C4 7.51472 4 10.3431 4 16C4 21.6568 4 24.4852 5.75736 26.2426C7.51472 28 10.3431 28 16 28H20"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
        />{" "}
        <path
          d="M20 32C20 26.3432 20 23.5148 21.7574 21.7574C23.5148 20 26.3432 20 32 20C37.6568 20 40.4852 20 42.2426 21.7574C44 23.5148 44 26.3432 44 32C44 37.6568 44 40.4852 42.2426 42.2426C40.4852 44 37.6568 44 32 44C26.3432 44 23.5148 44 21.7574 42.2426C20 40.4852 20 37.6568 20 32Z"
          stroke="#89A8B0"
          strokeWidth="4"
        />{" "}
        <path
          d="M8 33C8 35.809 8 37.2134 8.67412 38.2222C8.96596 38.659 9.34096 39.034 9.77772 39.3258C10.7866 40 12.1911 40 15 40"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M40 15C40 12.1911 40 10.7866 39.3258 9.77772C39.034 9.34096 38.659 8.96596 38.2222 8.67412C37.2134 8 35.809 8 33 8"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
      </svg>
    ),
  },
  {
    title: "Minimal Time Commitment",
    description:
      "No need to monitor charts or make trading decisions—the system does it for you.",
    icon: (
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M19.3333 16.1967V13.5946C19.3333 10.6647 20.5562 8.13921 22.358 6.01021C23.0588 5.18211 23.4092 4.76807 24 4.76807C24.5908 4.76807 24.9412 5.18211 25.642 6.01021C27.4438 8.13921 28.6666 10.6647 28.6666 13.5946V16.1967C28.6666 18.3395 28.6666 18.9488 29.9614 19.8861C30.997 20.5519 32 21.1967 32 22.4877C32 24.0539 31.3334 24.7681 29.8716 24.7681H18.1283C16.6667 24.7681 16 24.0539 16 22.4877C16 21.1967 17.0029 20.5519 18.0387 19.8861C19.3333 18.9488 19.3333 18.3395 19.3333 16.1967Z"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M39 44.7681C41.7614 44.7681 44 42.3803 44 39.4347C44 36.4893 41.7614 34.1015 39 34.1015C39 31.1559 36.7614 28.7681 34 28.7681"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M9 44.7681C6.23858 44.7681 4 42.3803 4 39.4347C4 36.4893 6.23858 34.1015 9 34.1015C9 31.1559 11.2386 28.7681 14 28.7681"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
        <path
          d="M20 30.7681V40.7681"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
        />{" "}
        <path
          d="M28 30.7681V34.7681"
          stroke="#89A8B0"
          strokeWidth="4"
          strokeLinecap="round"
        />{" "}
      </svg>
    ),
  },
  {
    title: "Potential for High Returns",
    description:
      "Gain exposure to professional trading strategies designed for growth.",
    icon: (
      <svg
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {" "}
        <path
          d="M17.4609 43.7661C20.0452 39.3201 25.9638 38.7959 29.3346 42.1933C30.0882 42.9529 30.465 43.3329 30.7992 43.3783C31.1334 43.4237 33.2304 42.2211 33.9748 41.7943C34.7336 41.3593 36.8374 40.1525 36.9696 39.8369C37.1018 39.5211 36.9634 38.9829 36.6866 37.9065C35.6798 33.9923 38.1212 29.8729 42.022 28.8105C43.0658 28.5261 43.5876 28.3838 43.7938 28.112C44 27.8402 44 25.4498 44 24.5752C44 23.7008 44 21.3102 43.7938 21.0384C43.5876 20.7666 43.0658 20.6244 42.022 20.3402C38.1206 19.2777 35.6772 15.1584 36.6836 11.244C36.9602 10.1674 37.0986 9.62911 36.9664 9.31347C36.8342 8.99785 34.7304 7.79123 33.9718 7.35617C33.2272 6.92925 31.1302 5.72669 30.7962 5.77213C30.462 5.81761 30.0852 6.19739 29.3314 6.95699C26.4128 9.89783 21.584 9.89795 18.6655 6.95717C17.9117 6.19759 17.5348 5.81779 17.2007 5.77235C16.8666 5.72689 14.7697 6.92947 14.0252 7.35641C13.2665 7.79149 11.1625 8.99807 11.0303 9.31375C10.8981 9.62943 11.0366 10.1676 11.3134 11.2441C12.3202 15.1584 9.8788 19.2776 5.97804 20.3401C4.93422 20.6244 4.4123 20.7666 4.20616 21.0386C4 21.3102 4 23.7008 4 24.5752C4 25.4498 4 27.8403 4.20616 28.1123C4.41234 28.3841 4.934 28.5261 5.97732 28.8103C5.98956 28.8137 6.00178 28.8171 6.014 28.8203"
          stroke="#89A8B0"
          strokeWidth="3"
          strokeLinecap="round"
        />{" "}
        <path
          d="M4.97782 37.1337C7.13782 34.9747 14.4818 27.7057 15.2018 26.8659C15.963 25.9783 15.3458 24.7789 15.713 21.0603C15.8907 19.2611 16.2779 17.9131 17.3858 16.9101C18.7058 15.6626 19.7858 15.6626 23.5058 15.5786C26.7458 15.6626 27.1298 15.3027 27.4658 16.1424C27.7058 16.7421 26.9858 17.102 26.1218 18.0616C24.2018 19.9808 23.0738 20.9405 22.9658 21.5403C22.1858 24.1791 25.2578 25.7385 26.9378 24.0591C27.5732 23.4241 30.5138 20.4606 30.8018 20.2207C31.0178 20.0288 31.5348 20.0381 31.7858 20.3406C32.0018 20.5528 32.0258 20.5805 32.0018 21.5401C31.9796 22.4285 31.9896 23.7037 31.9922 25.0187C31.9958 26.7227 31.9058 28.6173 31.1858 29.5769C29.7458 31.7359 27.3458 31.8559 25.1858 31.9519C23.1458 32.0719 21.4658 31.8559 20.9378 32.2397C20.5058 32.4557 18.2258 34.8547 15.4658 37.6135L10.5458 42.5315C6.46582 45.7703 1.97782 40.7323 4.97782 37.1337Z"
          stroke="#89A8B0"
          strokeWidth="3"
          strokeLinecap="round"
        />{" "}
      </svg>
    ),
  },
];

export default function SmartChoice() {
  return (
    <div className="feature-bg text-white pb-[260px]" id="feature-section">
      <div className="container mx-auto px-4">
        <section className="flex flex-col items-center justify-center lg:space-y-16 space-y-10 py-10 lg:py-16 text-white">
          <Heading
            title={"Smart Choice"}
            desc={"Here’s why it’s a smart choice for investors:"}
          />

          <div className="grid grid-cols-2 md:grid-cols-4  text-white border border-gray-700 rounded-xl">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`border-gray-700 p-6 relative ${index !== features.length - 1 ? "border-b md:border-b-0 md:border-r" : ""} ${index % 2 ? "" : "border-r"}`}
              >
                <div className="text-4xl mb-4 p-4 bg-[#89A8B0] bg-opacity-[0.06] inline-flex rounded-md">
                  {feature.icon}
                </div>
                <h3 className="text-md md:text-2xl font-semibold">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm md:text-md mt-2 mb-16">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12 px-6">
            <p className="text-gray-300">
              Whether you’re new to forex or a seasoned investor looking for a
              low-maintenance, high-potential opportunity, the PROFITPULSE EA
              PAMM account is designed to put your capital to work safely and
              effectively.
            </p>
            <p className="text-lg font-bold text-gray-300 mt-4">
              <span className="text-[#87A3A8] mr-2">Brokerage:</span> Plexytrade
              &nbsp; | &nbsp;
              <span className="text-[#87A3A8] mr-2">Performance Fee:</span> 30%
              &nbsp; | &nbsp;
              <span className="text-[#87A3A8] mr-2">Minimum Deposit:</span> $500
            </p>
            <p className="text-gray-300 text-sm mt-4">
              Withdrawals are restricted during open trades. All terms of
              service and LPOA must be accepted on the Plexytrade platform for
              acceptance into the PAMM.
            </p>
          </div>
        </section>
      </div>

      <div className="container mx-auto px-4">
        <section className="flex flex-col items-center justify-center py-10 lg:py-16 text-white">
          <div className="w-full max-w-4xl">
            <div className="mb-6 flex flex-col justify-between sm:text-center sm:flex-col md:flex-row md:justify-between">
              <p className="mb-4 font-semibold text-white md:mb-0 md:text-left lg:text-left text-center">
                To join log into your Plexytrade account first and <br />
                then click on the JOIN PAMM button :
              </p>

              <div className="flex justify-center sm:justify-center md:justify-center">
                <a
                  href="https://my.plexytrade.com/en/pamm?pm=41bfa94d3830b2a0f9fa43799d938b79"
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full bg-[#87A3A8] px-10 py-3 text-sm font-medium text-black shadow-md transition hover:bg-opacity-80"
                >
                  JOIN PAMM
                </a>
              </div>
            </div>

            <div className="rounded-xl bg-white bg-opacity-[0.02] border border-gray-500 p-6 shadow-lg">
              <div className="mb-4 grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-4">
                <div className="rounded-lg bg-[#87A3A8] bg-opacity-[0.12] p-4">
                  <p className="text-sm text-gray-400">Gains %</p>
                  <p className="text-lg font-semibold text-white">5.90</p>
                </div>
                <div className="rounded-lg bg-[#87A3A8] bg-opacity-[0.12] p-4">
                  <p className="text-sm text-gray-400">Balance $</p>
                  <p className="text-lg font-semibold text-white">16,167</p>
                </div>
                <div className="rounded-lg bg-[#87A3A8] bg-opacity-[0.12] p-4">
                  <p className="text-sm text-gray-400">Equity %</p>
                  <p className="text-lg font-semibold text-white">16,167</p>
                </div>
                <div className="rounded-lg bg-[#631B1B] bg-opacity-[0.12] p-4">
                  <p className="text-sm text-gray-400">Max drawdown %</p>
                  <p className="text-lg font-semibold text-red-500">4.0</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-2">
                <div className="rounded-lg bg-[#87A3A8] bg-opacity-[0.12] p-4">
                  <p className="text-sm text-gray-400">Profit $</p>
                  <p className="text-lg font-semibold text-white">1,617</p>
                </div>
                <div className="rounded-lg bg-[#87A3A8] bg-opacity-[0.12] p-4">
                  <p className="text-sm text-gray-400">Monthly avg %</p>
                  <p className="text-lg font-semibold text-white">8.4</p>
                </div>
              </div>

              <div className="mt-4 flex sm:flex-row lg:flex-row items-center lg:items-center sm:justify-start">
                <label className="mb-2 font-semibold text-white sm:mb-0 sm:mr-4 lg:mb-2 w-full lg:w-1/5">
                  As of this date:
                </label>
                <input
                  type="text"
                  className="rounded-lg border px-4 py-2 text-white w-full sm:w-full md:w-1/2 lg:w-1/4 date-picker"
                  value="02/25/2025"
                  readonly
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
